// The single shared money formatter for The Racket Center (UX brief §2).
//
// Convention: CURRENCY-FIRST, e.g. `USD 30`. This matches the payment surfaces
// already live (SlotPaymentRow.priceLabel, memberships planPriceLine). A trailing
// `.00` is trimmed ("USD 30", not "USD 30.00"); non-round amounts keep two
// decimals ("USD 30.50"). Use this everywhere a payment amount is rendered so the
// prior amount-first / currency-first drift ends here.
export function formatMoney(amount: number | null | undefined, currency: string | null | undefined): string {
  const cur = String(currency || '').trim().toUpperCase() || 'USD'
  const n = Number(amount)
  if (!Number.isFinite(n)) return `${cur} —`
  const body = n.toFixed(2).replace(/\.00$/, '')
  return `${cur} ${body}`
}
